<template>
  <section class="card-root">
    <section v-if="tooltipShow && tooltip" class="card-tooltip">
      <p class="card-tooltip_text">
        {{ tooltip }}
      </p>
    </section>
    <section
      class="card"
      :class="{ 'card--disabled': !selectedValue, 'card--deactivated' : disabled }"
    >
      <section v-if="isMobile" class="card-header--sp">
        <v-checkbox
          v-model="selectedValue"
          class="card-check"
          color="#CC0000"
          :disabled="disabled"
          hide-details
          :ripple="false"
        ></v-checkbox>

        <h5
          class="card-check_label"
          :class="{ 'card-check_label--selected': selectedValue }"
        >
          {{ selectedValue ? '選択中' : '未選択' }}
        </h5>
      </section>
      <section class="card-header">
        <v-checkbox
          v-model="selectedValue"
          class="card-check"
          color="#CC0000"
          :disabled="disabled"
          hide-details
          :ripple="false"
        ></v-checkbox>
        <v-img
          :max-height="isMobile ? 40 : 80"
          :max-width="isMobile ? 40 : 80"
          class="card-header_avatar"
          :src="avatar"
          alt=""
          srcset=""
        />
        <section class="card-header_title">
          <h4>{{ caption }}</h4>
          <h1>{{ title }}</h1>
        </section>
        <section class="card-header_right"></section>
      </section>
      <section class="card-contain">
        <v-divider />
        <slot> </slot>
      </section>
    </section>
    <h5 v-for="(note, noteIndex) in notes" :key="noteIndex" class="card-note">
      {{ note }}
    </h5>
    <h5 v-if="identifier" class="card-identifier">{{ identifier }}</h5>
    <div class="card-browse">
      <a
          v-if="browse"
          v-ripple
          target="_blank"
          :href="browse"
        >
          商品ページ<img src="image/icon_new_window_hd.svg" />
        </a>
        <a
          v-if="browse2"
          v-ripple
          target="_blank"
          :href="browse2"
        >
          {{ isMobile ? '家族の試算' : '家族の保険料を試算' }}<img src="image/icon_new_window_hd.svg" />
        </a>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'Card',
  props: {
    title: {
      type: String,
      default: '',
    },
    caption: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
    avatar: {
      type: String,
      default: '',
    },
    browse: {
      type: String,
      default: () => null,
    },
    browse2: {
      type: String,
      default: () => null,
    },
    notes: {
      type: Array,
      default: () => [],
    },
    identifier: {
      type: String,
      default: () => null,
    },
    tooltip: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tooltipShow: true,
    };
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.common.isMobile,
    }),
    selectedValue: {
      get() {
        return this.disabled ? false : this.selected;
      },
      set(value) {
        this.$emit('onSelect', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  border: solid 3px #CC0000;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  @media screen and (max-width: 767px) {
  }
  &--deactivated{
    filter:grayscale(100%);
    .card-header, .card-header--sp {
      background-color: #f4f4f4;
      &::v-deep .mdi-checkbox-blank-outline::before {
        color: #CCC;
      }
      &_title{
        h4, h1{
          color:#cccccc;
        }
      }
      .card-check_label{
        color: #CCC;
      }
    }
  }

  &--disabled {
    border-color: #ccc;
    .card-header--sp{
      background-color: #f4f4f4;
    }
    .card-contain {
      background-color: #f4f4f4;
    }
  }
  &-root {
    position: relative;
    margin-bottom: 20px;
  }
  &-check {
    margin-top: 0;
    padding-top: 0;
    margin-right: 20px;
    &::v-deep .v-input {
      &--selection-controls__input {
        width: 64px;
        height: 64px;
        .v-icon {
          font-size: 64px;
        }
      }
    }
    &_label {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #333;
      &--selected {
        color: #CC0000;
        font-weight: bold;
      }
    }
  }
  &-browse {
    position: absolute;
    top: 3px;
    right: 3px;
    padding: 2px 10px 2px 12px;
    background-color: #f4f4f4;
    border-bottom-left-radius: 10px;
    border-top-right-radius: 10px;
    z-index: 1;

    a{
      display: block;
      cursor: pointer;
      padding: 4px 0;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.69;
      letter-spacing: normal;
      text-align: right;
      text-decoration: none;
      color: #666;
      &:last-child{
        border-top: 1px solid #CCC;
      }
      img {
        margin-left: 2px;
      }
    }
  }
  &-header {
    position: relative;
    display: flex;
    padding: 15px 32px;
    align-items: center;
    &_avatar {
      margin-right: 36px;
    }
    &_title {
      & > h1 {
        font-size: 28px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        margin-bottom: 0;
        letter-spacing: normal;
        text-align: left;
        color: #333;
      }
      & > h4 {
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #333;
        margin-bottom: 0;
      }
    }
  }
  &-contain {
    background-color: #FAE6E6;
    border-radius: 0 0 10px 10px;
  }
  &-note {
    &:first-of-type{
      font-size: 13px;
      font-weight: 700;
    }

    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #999;
    margin-top: 5px;
    margin-bottom: 3px;
    padding-left:1em;
	  text-indent:-1em;
    white-space: pre-wrap;
  }
  &-identifier{
    margin-top: 5px;
    font-size: 12px;
  }
  &-tooltip {
    background-color: #FA000F;
    padding: 8px 14px;
    width: fit-content;
    border-radius: 10px;
    position: absolute;
    top: -51px;
    &_text {
      font-size: 18px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.28;
      letter-spacing: normal;
      text-align: left;
      color: #FFF;
      margin-bottom: 0;
    }

    &:after,
    &:before {
      top: 100%;
      left: 20%;
      border: solid transparent;
      content: '';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

    &:after {
      border-color: rgba(255, 255, 255, 0);
      border-top-color: #FA000F;
      border-width: 10px;
      margin-left: -10px;
    }

    &:before {
      border-color: rgba(108, 134, 206, 0);
      border-top-color: #FA000F;
      border-width: 11px;
      margin-left: -11px;
    }
  }

  // mobile
  @media screen and (max-width: 767px) {
    &-header {
      padding: 10px;
      &--sp {
        display: flex;
        align-items: center;
        height: 44px;
        background-color: #FAE6E6;
        .card-check {
          margin-left: 12px;
          margin-right: 0;
          &::v-deep .v-input {
            &--selection-controls__input {
              width: 44px;
              height: 44px;
              .v-icon {
                font-size: 44px;
              }
            }
          }
        }
      }
      &_title {
        margin-left: 15px;
        h4 {
          font-size: 12px;
        }
        h1 {
          font-size: 24px;
        }
      }
      &_avatar {
        margin-right: 0;
      }
      .card-check {
        display: none;
      }
    }
    &-browse {
      background-color: transparent;
      top: 7px;
      a{
        display: inline-block;
        padding-left: 10px;
        &:last-child{
        border-top: none;
      }
      }
    }
    &-tooltip {
      top: -45px;
      &_text {
        font-size: 13px !important;
      }
    }
  }
}
</style>
